import React from "react";
import "./erro.scss";

export default function ErroAnim() {
  return (
    <div className="erroAnim">
      <div className="container">
        <div className="circle-border"></div>
        <div className="circle">
          <div className="errorAnim"></div>
        </div>
      </div>
    </div>
  );
}
